import { inject, Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { LookupService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class ColumnLabelResolver implements Resolve<boolean> {
  private lookUpService= inject(LookupService);
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.lookUpService.getEnumItems('BlockColumnLabelType').pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
